import { throwError } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import { catchError } from 'rxjs/operators'
import { env } from 'shared/env'

const baseURL = env.SERVER_ADDR

const requestHeader = () => {
  const headers = {
    'Content-Type': 'application/json',
  }
  const userData = JSON.parse(localStorage.getItem('user_info') || '{}')
  let token: string | boolean = false
  if (userData.token) {
    token = userData.token
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  return headers
}

const handleError = (operation: string) => (err: any) => {
  const errMsg = `Error in ${operation}()`

  if (err.status === 401) {
    localStorage.clear()
    window.location.href = '/auth/login'
  }
  return throwError(() => console.error(errMsg))
}

export const getPaymentSummary = () =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/vendors/my/payments`,
  }).pipe(catchError(handleError('login')))

export const getContracts = () =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/vendors/contracts`,
  }).pipe(catchError(handleError('login')))
